import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const LedgerKind = z.enum([
    'bet',
    'win',
    'signup_bonus',
    'fever_bonus',
    'daily_bonus',
    'iap',
    'admin_adjust',
    'onboarding_fever',
    'invite_signup_bonus',
    'invite_inviter_bonus',
    'friend_gift',
    're_invite_gift',
    'leaderboard_prize',
    'leaderboard_prize_manual',
    'refund_clawback',
]);
export const LedgerEntry = z.object({
    id: z.number().int(),
    user_id: z.string(),
    amount: z.number().int(),
    kind: LedgerKind,
    spin_id: z.string().nullable(),
    game_id: z.string().nullable(),
    idempotency_key: z.string().nullable(),
    meta: z.record(z.unknown()),
    ts: IsoDateTime,
});
export const AdminLedgerListRequest = PageRequest.extend({
    user_id: z.string().optional(),
    kind: LedgerKind.optional(),
    ts_after: IsoDateTime.optional(),
    ts_before: IsoDateTime.optional(),
    amount_min: z.number().int().optional(),
    amount_max: z.number().int().optional(),
    idempotency_key: z.string().optional(),
    game_id: z.string().optional(),
});
export const AdminLedgerListResponse = z.object({
    items: z.array(LedgerEntry),
    page: PageMeta,
    sum_amount: z.number().int(),
});
export const AdminLedgerReconcileRequest = z.object({
    user_id: z.string().optional(),
    reason: MutationReason,
});
export const AdminLedgerReconcileResponse = z.object({
    scope: z.enum(['single_user', 'all_users']),
    users_checked: z.number().int(),
    drift_count: z.number().int(),
    drift: z.array(z.object({
        user_id: z.string(),
        cache_balance: z.number().int(),
        ledger_sum: z.number().int(),
        diff: z.number().int(),
    })),
    fixed: z.boolean(),
});
export const AdminLedgerExportRequest = z.object({
    ts_after: IsoDateTime,
    ts_before: IsoDateTime,
    format: z.enum(['csv', 'jsonl']).default('csv'),
    reason: MutationReason,
});
export const AdminLedgerExportResponse = z.object({
    job_id: z.string(),
    estimated_rows: z.number().int(),
    download_url: z.string().nullable(),
    status: z.enum(['queued', 'running', 'completed', 'failed']),
});
//# sourceMappingURL=ledger.js.map